import { useEffect, useRef } from "react";
import { useMiroJobs } from "context/MiroJobsContext";
import { useAppSelector } from "store";

/**
 * Once per app start, for an authorized user: ask the BE which Miro jobs are
 * running (or just finished) and hand them to the jobs provider. Renders nothing. A reload loses the in-memory
 * jobs; this is what gets the progress indicator, the polling and the completion notice back (REF-6702).
 *
 * It is a component of its own so the provider stays free of Redux: the permission payload and the auth flag
 * arrive after first render, and the effect simply waits for both.
 */
const MiroJobsResumer = () => {
  const isAuthorized = useAppSelector((state) => state.common.isAuthorized);
  const { resume } = useMiroJobs();
  const ranRef = useRef(false);

  useEffect(() => {
    if (!isAuthorized || ranRef.current) return;
    ranRef.current = true;
    void resume();
  }, [isAuthorized, resume]);

  return null;
};

export default MiroJobsResumer;
